import useRefetchWidget from "@/features/shared/widgets/hooks/useRefetchWidget";
import { HTMLTextContainer } from "@/features/shared/widgets/components";

type ErrorObject = {
  error: string;
  filename: string;
  http_error: string;
  not_found_message?: string;
};

const isDataError = (data: string | object): data is ErrorObject => {
  return typeof data === "object" && "error" in data;
};

const Text = ({ id, data }: { id: string; data: string | object }) => {
  const content = isDataError(data)
    ? (data?.not_found_message ?? data.error)
    : String(data);

  useRefetchWidget(id);

  return <HTMLTextContainer content={content} />;
};

export default Text;
